export type MyPricesEmptyStateKind = 'not-imported' | 'all-checked' | 'filtered'

type MyPricesEmptyStateInput = {
  totalItems: number
  needsAttention: number
  attentionOnly: boolean
}

/** Separates an empty import from a completed attention-review flow. */
export const getMyPricesEmptyState = ({
  totalItems,
  needsAttention,
  attentionOnly,
}: MyPricesEmptyStateInput): MyPricesEmptyStateKind => {
  if (totalItems <= 0) return 'not-imported'
  if (attentionOnly && needsAttention === 0) return 'all-checked'
  return 'filtered'
}
